module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/no-autorizado/no-autorizado.component.css
// module id = ./src/app/no-autorizado/no-autorizado.component.css
// module chunks = main